import { isTablet, isIPad13, isChrome } from 'react-device-detect';

import CookieStorageService from 'services/CookieStorageService';


const comingFromGoogleSearch = CookieStorageService.get('dontShowPopAds') === 'true';

export const dontShowPopAds = (
  window.IS_BOT ||
  isTablet ||
  isIPad13 ||
  isChrome ||
  comingFromGoogleSearch
);

export const hideAdsCookie = CookieStorageService.get('cam4-HideAds') === 'true';

export const generateAdUrl = (id) => {
  const currentUrl = top === self ? document.URL : document.referrer;

  const url =
    `//s.st1net.com/splash.php
    ?block=1
    &cookieconsent=true
    &idzone=${id}
    &p=${encodeURIComponent(currentUrl)}
    &type=8`;

  return url.replace(/\s/g, '');
};

const AD_ID_PRIMARY_DESKTOP_STRAIGHT = 172;
const AD_ID_PRIMARY_DESKTOP_GAY = 174;
const AD_ID_PRIMARY_DESKTOP_TRANS = 176;
const AD_ID_PRIMARY_MOBILE_STRAIGHT = 178;
const AD_ID_PRIMARY_MOBILE_GAY = 180;
const AD_ID_PRIMARY_MOBILE_TRANS = 182;

const AD_ID_SECONDARY_DESKTOP_STRAIGHT = 2248;
const AD_ID_SECONDARY_DESKTOP_GAY = 2250;
const AD_ID_SECONDARY_DESKTOP_TRANS = 2252;
const AD_ID_SECONDARY_MOBILE_STRAIGHT = 2254;
const AD_ID_SECONDARY_MOBILE_GAY = 2256;
const AD_ID_SECONDARY_MOBILE_TRANS = 2258;

export const LINKS = {
  primary: {
    desktop: {
      straight: generateAdUrl(AD_ID_PRIMARY_DESKTOP_STRAIGHT),
      gay: generateAdUrl(AD_ID_PRIMARY_DESKTOP_GAY),
      trans: generateAdUrl(AD_ID_PRIMARY_DESKTOP_TRANS),
    },
    mobile: {
      straight: generateAdUrl(AD_ID_PRIMARY_MOBILE_STRAIGHT),
      gay: generateAdUrl(AD_ID_PRIMARY_MOBILE_GAY),
      trans: generateAdUrl(AD_ID_PRIMARY_MOBILE_TRANS),
    },
  },
  secondary: {
    desktop: {
      straight: generateAdUrl(AD_ID_SECONDARY_DESKTOP_STRAIGHT),
      gay: generateAdUrl(AD_ID_SECONDARY_DESKTOP_GAY),
      trans: generateAdUrl(AD_ID_SECONDARY_DESKTOP_TRANS),
    },
    mobile: {
      straight: generateAdUrl(AD_ID_SECONDARY_MOBILE_STRAIGHT),
      gay: generateAdUrl(AD_ID_SECONDARY_MOBILE_GAY),
      trans: generateAdUrl(AD_ID_SECONDARY_MOBILE_TRANS),
    },
  },
};

export const popupOptions = `
  toolbar=no,
  scrollbars=yes,
  location=yes,
  statusbar=yes,
  menubar=no,
  resizable=1,
  width=1000,
  height=750
  `.replace(/\s/g, '');

export const getPopunderOptions = () => {
  const {
    outerWidth,
    innerWidth,
    outerHeight,
    innerHeight,
  } = window;

  const width = outerWidth || innerWidth;
  const height = (outerHeight - 100) || innerHeight;

  const updatedOptions = `
    toolbar=no,
    scrollbars=yes,
    location=yes,
    statusbar=yes,
    menubar=no,
    resizable=1,
    width=${width},
    height=${height},
    screenX=0,
    screenY=0
  `;

  return updatedOptions.replace(/\s/g, '');
};
